import { ShimmerMetricRow } from "./DashboardShimmer";
import AverageWeights from "./AverageWeights";
import RunningTotalsExtra from "./RunningTotalsExtra";
import LossMetrics from "./LossMetrics";
import FruitQualityMetrics from "./FruitQualityMetrics";
import "./dashboard-sections.css";
import DashboardSummaryBox from "./DashboardSummaryBox";
import SlickSlider from "../../slider/SlickSlider";
import { useGetFreshFruitRunningTotalQuery } from "../dashBoardApi";
import { useState } from "react";
import { getCurrentDate, makeLotNumber, makePriorLotNumber } from "../../../helpers/Utils";

const SlickArrow = ({ direction, onClick }) => (
  <button
    type="button"
    className={`db-slick-arrow db-slick-${direction}`}
    onClick={onClick}
    aria-label={direction === "prev" ? "Previous" : "Next"}
  >
    {direction === "prev" ? (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    ) : (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    )}
  </button>
);

const FreshFruitRunningTotals = () => {
  const [currentDate] = useState(getCurrentDate("YYYY-MM-DD"));

  const {
    data: freshFruitData,
    isLoading: isFreshFruitLoading,
  } = useGetFreshFruitRunningTotalQuery({
    date: currentDate,
    priorLotNumber: makePriorLotNumber(currentDate),
    currentLotNumber: makeLotNumber(),
  });

  const data = freshFruitData?.data || {};

  const metrics = [
    { label: "Total Paid Cases",       value: data?.slider_data?.total_paid_cases?.toLocaleString(),       unit: ""   },
    { label: "Total Paid KG",          value: data?.slider_data?.total_paid_kg?.toLocaleString(),          unit: "kg" },
    { label: "Total Orange KG",        value: data?.slider_data?.total_orange_kg?.toLocaleString(),        unit: "kg" },
    { label: "Total Already Ripened",  value: data?.slider_data?.total_already_ripened?.toLocaleString(),  unit: "kg" },
    { label: "Total Rejected KG",      value: data?.slider_data?.total_rejected_kg?.toLocaleString(),      unit: "",  danger: true, dot: true },
  ];

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: true,
    nextArrow: <SlickArrow direction="next" />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 768,  settings: { slidesToShow: 2 } },
      { breakpoint: 480,  settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="db-section">
      {/* ── Slider ── */}
      {isFreshFruitLoading ? (
        <ShimmerMetricRow count={5} />
      ) : (
        <div className="db-slick-wrapper mb-3">
          <SlickSlider settings={slickSettings}>
            {metrics.map((item, i) => (
              <div key={`${item.label}-${i}`} className="db-slick-slide">
                <DashboardSummaryBox data={item} />
              </div>
            ))}
          </SlickSlider>
        </div>
      )}

      {/* ── Main layout: left content | right panel ── */}
      <div className="ffrt-main-layout">

        {/* Left: Avg Weights + Processing + Packing */}
        <div className="ffrt-left-col">
          <AverageWeights isLoading={isFreshFruitLoading} data={data?.average_weights} />
          <RunningTotalsExtra
            isLoading={isFreshFruitLoading}
            data={data}
          />
        </div>

        {/* Right: Processing Metrics panel spanning full height */}
        <div className="ffrt-right-col">
          <LossMetrics isLoading={isFreshFruitLoading} data={data} />
        </div>
      </div>

      {/* ── Bottom: Fruit Quality Metrics full width ── */}
      <div className="mt-3">
        <FruitQualityMetrics isLoading={isFreshFruitLoading} data={data?.quality_metrics} />
      </div>
    </div>
  );
};

export default FreshFruitRunningTotals;
